//frontend/src/hooks/useArrivalPoll.js

import { useRegion } from '../contexts/RegionContext';
import { usePolledResource } from './usePolledResource';

export function useArrivalPoll(routeId, direction) {
  const { adapter } = useRegion();
  const date = adapter.getTodayDate();
  const active = Boolean(routeId);

  const { data, loading, error } = usePolledResource(
    () => adapter.fetchArrivalBoard(routeId, direction, date),
    [routeId, direction, date, adapter],
    { enabled: active, refetchInterval: 30000, initialData: null }
  );

  return {
    stops: data?.stops ?? [],
    trips: data?.trips ?? [],
    rawArrivals: data?.rawArrivals ?? [],
    loading,
    error,
  };
}